import { BudgetCostReq, CommonResponseModel, Divisionreq} from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";


export class DivisionService extends CommonAxiosService {
    private BudgetController = "/division";

    async createDivision(payload: Divisionreq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.BudgetController + "/createDivision", payload)
    }

    async getAllDivision(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.BudgetController + "/getAllDivision")
    }

    async getAllActiveDivision(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.BudgetController + "/getAllActiveDivision")
    }
    async updateDivision(dto: Divisionreq): Promise<CommonResponseModel> {
        return await this.axiosPostCall(this.BudgetController + '/updateDivision', dto)
    }

    async activateOrDeactivateDivision(payload: Divisionreq): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.BudgetController + "/activateOrDeactivateDivision", payload)
    }

}